import { NotOverridableComponentProps } from '../../../../../model/Component'
import Tabs, { TabsProps } from '@mui/material/Tabs'
import { AppBox } from '../AppBox'

export type AppTabListProps = NotOverridableComponentProps<TabsProps>

export function AppTabList(props: AppTabListProps) {
  return (
    <AppBox
      {...props}
      component={Tabs}
    />
  )
}
